import comp from "./LECard";
export default comp;
